import { Box, Grid, Step, StepLabel } from '@mui/material';
import { useState, useEffect } from 'react';
import { TextField } from '../../components/common';
import Stepper from '../../components/common/Stepper';
import AnimalSimulationParameters from './Steps/AnimalSimulationParameters';
import PlantSimulationParameters from './Steps/PlantSimulationParameters';
import SimulationMultipleClients from './Steps/SimulationMultipleClients';
import { Button } from '../../components/common';
import { useHistory } from 'react-router-dom';
import useForm from '../../hooks/useForm';
import { incomeParameters, simulation } from '../../utils/api';

const steps = [
  'Zdefiniuj symulację',
  'Określ wskaźniki symulacji dla produkcji roślinnej',
  'Określ wskaźniki symulacji dla produkcji zwierzęcej',
  'Wygeneruj symulację',
];

export default function AddSimulation(props) {
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);

  const [animalParameters, setAnimalParameters] = useState([]);
  const [animalParametersSelection, setAnimalParametersSelection] = useState(
    []
  );
  const [animalParametersData, setAnimalParametersData] = useState([]);

  const [plantParameters, setPlantParameters] = useState([]);
  const [plantParametersSelection, setPlantParametersSelection] = useState([]);
  const [plantParametersData, setPlantParametersData] = useState([]);

  const [clients, setClients] = useState([]);
  const [clientsSelection, setClientsSelection] = useState([]);

  const [resultID, setResultID] = useState();

  const { values, handleChange } = useForm({
    name: '',
    description: '',
  });

  useEffect(() => {
    incomeParameters
      .crop()
      .then((res) => {
        setPlantParametersData(
          res.data.map((e) => {
            return { ...e, edited: false };
          })
        );
      })
      .catch((err) => {});
    incomeParameters
      .animals()
      .then((res) => {
        setAnimalParametersData(
          res.data.map((e) => {
            return { ...e, edited: false };
          })
        );
      })
      .catch((err) => {});
    //eslint-disable-next-line
  }, []);

  const handleNext = () => {
    if (activeStep === 2) {
      const crops = plantParametersData.filter((e) => {
        if (e.edited) return true;
        return false;
      });

      const animals = animalParametersData.filter((e) => {
        if (e.edited) return true;
        return false;
      });
      simulation
        .create({
          animalIncomeParameterRequestList: animals,
          cropIncomeParameterRequestList: crops,
          name: values.name,
          description: values.description,
        })
        .then((res) => {
          setResultID(res.data);
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        })
        .catch((err) => {});
    } else if (activeStep === steps.length - 1)
      history.push('/dashboard/simulation');
    else setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      history.push('/dashboard/simulation');
    } else setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const deleteSimulation = () => {
    simulation
      .delete(resultID)
      .then((res) => {
        history.push('/dashboard/simulation');
      })
      .catch((err) => {});
  };

  return (
    <Box sx={{ mt: 5 }}>
      <Grid container justifyContent="center">
        <Box sx={{ width: '90%', mt: 6 }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              return (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </Box>

        <Box
          alignItems="center"
          sx={{
            my: 2,
            display: 'flex',
            flexDirection: 'row',
            pt: 2,
            width: '90%',
            px: 3,
          }}
        >
          <Button
            variant="contained"
            onClick={handleBack}
            sx={{ mr: 3, px: 5, py: 3, maxHeight: 60 }}
          >
            WRÓĆ
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          {activeStep === steps.length - 1 && (
            <Button
              redDelete
              variant="contained"
              onClick={deleteSimulation}
              sx={{
                px: 5,
                py: 3,
                maxHeight: 60,
                mr: 2,
              }}
            >
              PORZUĆ SYMULACJĘ
            </Button>
          )}
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{ px: 5, py: 3, maxHeight: 60 }}
            disabled={!values.name || !values.description}
          >
            {activeStep === steps.length - 1 ? 'ZAPISZ SYMULACJĘ' : 'DALEJ'}
          </Button>
        </Box>
      </Grid>
      {activeStep === 0 && (
        <Grid
          container
          sx={{ mt: 5, px: 6 }}
          justifyContent="space-evenly"
          columnSpacing={{ lg: 5 }}
        >
          <Grid item xs={12} md={8} lg={4}>
            <TextField
              modalRight
              fullWidth
              label="Nazwa symulacji"
              value={values.name}
              onChange={handleChange('name')}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={8}>
            <TextField
              modalRight
              fullWidth
              label="Opis symulacji"
              value={values.description}
              onChange={handleChange('description')}
            />
          </Grid>
        </Grid>
      )}
      {activeStep === 1 && (
        <PlantSimulationParameters
          plantParameters={plantParameters}
          setPlantParameters={setPlantParameters}
          data={plantParametersData}
          setData={setPlantParametersData}
          selection={plantParametersSelection}
          setSelection={setPlantParametersSelection}
        />
      )}
      {activeStep === 2 && (
        <AnimalSimulationParameters
          animalParameters={animalParameters}
          setAnimalParameters={setAnimalParameters}
          data={animalParametersData}
          setData={setAnimalParametersData}
          selection={animalParametersSelection}
          setSelection={setAnimalParametersSelection}
        />
      )}
      {activeStep === 3 && (
        <SimulationMultipleClients
          clients={clients}
          setClients={setClients}
          selection={clientsSelection}
          setSelection={setClientsSelection}
          resultID={resultID}
        />
      )}
    </Box>
  );
}
